import "./Tournaments.module.css";
import Header from "@/reusable_sections/Header";
import ExpertSolutions from "./sections/ExpertSolutions";
import TournamentsArchive from "./sections/TournamentsArchive";
import TournamentsUpcoming from "./sections/TournamentsUpcoming";
import RejoignezLAventure from "@/reusable_sections/Footer";
export default function TournamentsPage() {
  return <div>
      <Header />
      {/* <ExpertSolutions /> */}
      <TournamentsUpcoming />
      <TournamentsArchive />
      <RejoignezLAventure />
    </div>;
}